import Vue from "vue";
import Vuelidate from "vuelidate";
import PPC from "@/components/PPC.vue";
import StorePromo from "@/components/StorePromo.vue";
import BootstrapVue from "bootstrap-vue";
import store from "./store/store";
import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueGtm, {
  id: "GTM-PLHN39K",
  queryParams: {},
  debug: false,
  loadScript: true,
});
Vue.config.productionTip = false;
Vue.config.devtools = true;

new Vue({
  render: (h) => h(PPC),
  store,
}).$mount("#ppc");
new Vue({
  render: (h) => h(StorePromo, { props: { formType: "ppc" } }),
  store,
}).$mount("#promotion-insert");
